import { render, staticRenderFns } from "./PackageDefinition.vue?vue&type=template&id=2633127f&scoped=true&"
import script from "./PackageDefinition.vue?vue&type=script&lang=ts&"
export * from "./PackageDefinition.vue?vue&type=script&lang=ts&"
import style0 from "./PackageDefinition.vue?vue&type=style&index=0&id=2633127f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633127f",
  null
  
)

export default component.exports